import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useMemo, useState, useCallback } from 'react';
import { PROFFIT_SEARCH_PLAN_FUNCTIONS_LP_PAGE, PROFFIT_SEARCH_PLAN_FREE, PROFFIT_SEARCH_PLAN_STANDARD, PROFFIT_SEARCH_PLAN_ADVANCED, } from '../../../../../define/consts/proffit_search/proffit_search_service';
import { propBool, propFunc, propStr, } from '../../../../../helpers/custom-prop-types';
import ProffitSearchLandingPageSectionTitle from '../../Parts/ProffitSearchLandingPageSectionTitle';
import ProffitSearchLandingPagePlansBody from './ProffitSearchLandingPagePlansBody';
import ProffitSearchLandingPagePlansTab from './ProffitSearchLandingPagePlansTab';
const ProffitSearchLandingPagePlans = (props) => {
    const { isEndTrial, plan, showFormModal } = props;
    const [currentTab, changeCurrentTab] = useState(1);
    const onClickTab = useCallback((e) => {
        const { value } = e.currentTarget;
        changeCurrentTab(parseInt(value, 10));
    }, [changeCurrentTab]);
    const plans = useMemo(() => [
        Object.assign(Object.assign({}, PROFFIT_SEARCH_PLAN_FREE), { buttonText: '15日間無料トライアル' }),
        Object.assign(Object.assign({}, PROFFIT_SEARCH_PLAN_STANDARD), { buttonText: '15日間無料トライアル' }),
        Object.assign(Object.assign({}, PROFFIT_SEARCH_PLAN_ADVANCED), { buttonText: '2022年リリース予定', isDisabled: true }),
    ], []);
    return (_jsx("section", Object.assign({ className: 'proffit_search_landing_page_plans' }, { children: _jsxs("div", Object.assign({ className: 'plans_inner' }, { children: [_jsx(ProffitSearchLandingPageSectionTitle, { className: 'plans_title', mainText: _jsxs(_Fragment, { children: [_jsx("span", { children: "\u3054\u5229\u7528" }), _jsx("span", Object.assign({ className: 'title_text_blue' }, { children: "\u30D7\u30E9\u30F3" }))] }), subText: '用途に応じて' }), _jsx(ProffitSearchLandingPagePlansTab, { currentTab: currentTab, onClick: onClickTab, plans: plans }), _jsx(ProffitSearchLandingPagePlansBody, { currentTab: currentTab, functions: PROFFIT_SEARCH_PLAN_FUNCTIONS_LP_PAGE, isEndTrial: isEndTrial, plan: plan, plans: plans, showFormModal: showFormModal })] })) })));
};
ProffitSearchLandingPagePlans.propTypes = {
    isEndTrial: propBool().isRequired,
    plan: propStr(),
    showFormModal: propFunc().isRequired,
};
ProffitSearchLandingPagePlans.defaultProps = {
    plan: undefined,
};
export default ProffitSearchLandingPagePlans;
